var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var pushMatomoEvent = function (eventType) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (window._paq) {
        window._paq.push(["disableAlwaysUseSendBeacon"]);
        window._paq.push(__spreadArray([eventType], args, true));
    }
};
export var addToCart = function (sku, name, category, price, quantity) {
    pushMatomoEvent("addEcommerceItem", sku, name, category, price, quantity);
};
export var updateCart = function (total) {
    pushMatomoEvent("trackEcommerceCartUpdate", total);
};
export var removeFromCart = function (sku) {
    pushMatomoEvent("removeEcommerceItem", sku);
};
export var trackOrder = function (orderId, grandTotal, subTotal, tax, shipping, discount) {
    pushMatomoEvent("trackEcommerceOrder", orderId, grandTotal, subTotal, tax, shipping, discount);
};
